export const MODAL_TYPES_SEMAFORO = {
  ABRIR_FILTROS: "ABRIR FILTROS",
  ABRIR_CUENTACORRIENTE: "ABRIR_CUENTACORRIENTE",
  EXPORTAR_EXCEL: "EXPORTAR_EXCEL",
};
